import { render, staticRenderFns } from "./SidebarEditAddress.vue?vue&type=template&id=89997484&scoped=true"
import script from "./SidebarEditAddress.vue?vue&type=script&lang=js"
export * from "./SidebarEditAddress.vue?vue&type=script&lang=js"
import style0 from "./SidebarEditAddress.vue?vue&type=style&index=0&id=89997484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89997484",
  null
  
)

export default component.exports